"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/breadcrumbs/index.ts
var breadcrumbs_exports = {};
__export(breadcrumbs_exports, {
  Breadcrumbs: () => Breadcrumbs_default,
  default: () => Breadcrumbs_default
});
module.exports = __toCommonJS(breadcrumbs_exports);
var import_index2 = require("./index.css");

// src/breadcrumbs/Breadcrumbs.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react = require("react");

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/link/index.ts
var import_index = require("./index.css");

// src/link/Link.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/common/constants/index.ts
var externalLinkIconProps = {
  iconName: "up-right-from-square",
  iconStyle: "solid"
};

// src/link/link.module.scss
var link_module_default = {
  "heading-xxl": "link-module__heading-xxl___NWhiO",
  "wrapper": "link-module__wrapper___wxglA",
  "heading-xl": "link-module__heading-xl___reHWW",
  "heading-lg": "link-module__heading-lg___vrkyU",
  "heading-md": "link-module__heading-md___DgXip",
  "heading-sm": "link-module__heading-sm___p4wYS",
  "heading-xs": "link-module__heading-xs___4dzMP",
  "body-one": "link-module__body-one___9dMa8",
  "body-two": "link-module__body-two___A55Jq",
  "body-three": "link-module__body-three___U22yO",
  "body-four": "link-module__body-four___jLkaW",
  "overline-one": "link-module__overline-one___ujSBW",
  "overline-two": "link-module__overline-two___8OvVA",
  "overline-three": "link-module__overline-three___800o1",
  "strong": "link-module__strong___GfpHM",
  "extra-strong": "link-module__extra-strong___Tf0eY",
  "em": "link-module__em___ihSMB",
  "figcaption": "link-module__figcaption___hOiiQ",
  "no-margin": "link-module__no-margin___DOAhW",
  "link": "link-module__link___nBh09",
  "link-primary": "link-module__link-primary___Cgm-i",
  "link-secondary": "link-module__link-secondary___xHFLi",
  "link-l": "link-module__link-l___3mskp",
  "link-m": "link-module__link-m___aQawz",
  "link-s": "link-module__link-s___zlJ-K",
  "link-xs": "link-module__link-xs___Pg8mp"
};

// src/link/Link.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Link = ({
  children,
  text,
  id,
  className,
  external,
  openInNewTab,
  href = "#",
  disabled,
  onClick,
  size = "m",
  type = "primary",
  role,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
  "a",
  {
    className: (0, import_classnames2.default)(
      link_module_default.link,
      link_module_default[`link-${type}`],
      link_module_default[`link-${size}`],
      className
    ),
    href: !disabled ? href : void 0,
    id,
    onClick: !disabled ? onClick : void 0,
    rel: openInNewTab || external ? "noopener noreferrer" : void 0,
    target: (openInNewTab || void 0) && "_blank",
    role,
    ...disabled ? { "aria-disabled": true } : {},
    ...HTMLAttributes,
    children: [
      text || children,
      external && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { ...externalLinkIconProps })
    ]
  }
);
var Link_default = Link;

// src/breadcrumbs/breadcrumbs.module.scss
var breadcrumbs_module_default = {
  "heading-xxl": "breadcrumbs-module__heading-xxl___zsWzr",
  "wrapper": "breadcrumbs-module__wrapper___pr8fD",
  "heading-xl": "breadcrumbs-module__heading-xl___M-qRt",
  "heading-lg": "breadcrumbs-module__heading-lg___ynsy1",
  "heading-md": "breadcrumbs-module__heading-md___qsqWq",
  "heading-sm": "breadcrumbs-module__heading-sm___DfFnu",
  "heading-xs": "breadcrumbs-module__heading-xs___LNnvo",
  "body-one": "breadcrumbs-module__body-one___uMaZB",
  "body-two": "breadcrumbs-module__body-two___fruZY",
  "body-three": "breadcrumbs-module__body-three___orSCI",
  "body-four": "breadcrumbs-module__body-four___B6QIT",
  "overline-one": "breadcrumbs-module__overline-one___HF7iY",
  "overline-two": "breadcrumbs-module__overline-two___nLbvf",
  "overline-three": "breadcrumbs-module__overline-three___ve8Z0",
  "strong": "breadcrumbs-module__strong___6zeXP",
  "extra-strong": "breadcrumbs-module__extra-strong___-P8Gf",
  "em": "breadcrumbs-module__em___eoL6t",
  "figcaption": "breadcrumbs-module__figcaption___tqquP",
  "no-margin": "breadcrumbs-module__no-margin___upWSh",
  "breadcrumbs": "breadcrumbs-module__breadcrumbs___U-67E",
  "breadcrumb": "breadcrumbs-module__breadcrumb___StFkH",
  "homeIcon": "breadcrumbs-module__homeIcon___f8SPd",
  "breadcrumbs-l": "breadcrumbs-module__breadcrumbs-l___7QnG2",
  "breadcrumbs-m": "breadcrumbs-module__breadcrumbs-m___9OuTX",
  "breadcrumbs-s": "breadcrumbs-module__breadcrumbs-s___IyIWT",
  "breadcrumbs-xs": "breadcrumbs-module__breadcrumbs-xs___rXdk6"
};

// src/breadcrumbs/Breadcrumbs.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Breadcrumbs = ({
  breadcrumbs,
  name,
  size = "m",
  className,
  showHomeIcon = false,
  homeIconHref = "/"
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    "div",
    {
      className: (0, import_classnames3.default)(
        breadcrumbs_module_default.breadcrumbs,
        breadcrumbs_module_default[`breadcrumbs-${size}`],
        className
      ),
      "data-testid": `breadcrumbs-${name}`,
      children: [
        showHomeIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Link_default, { href: homeIconHref, className: breadcrumbs_module_default.breadcrumb, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
            FontAwesomeV6Icon_default,
            {
              iconName: "house",
              className: breadcrumbs_module_default.homeIcon,
              title: "Home"
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { iconName: "chevron-right" })
        ] }),
        breadcrumbs.map(({ href, ...rest }, i) => /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_react.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
            Link_default,
            {
              ...rest,
              href,
              className: (0, import_classnames3.default)(breadcrumbs_module_default.breadcrumb, rest.className),
              disabled: i === breadcrumbs.length - 1
            }
          ),
          i < breadcrumbs.length - 1 && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { iconName: "chevron-right" })
        ] }, href))
      ]
    }
  );
};
var Breadcrumbs_default = Breadcrumbs;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Breadcrumbs
});
//# sourceMappingURL=index.js.map